import { DurationUnit } from '../openapi/models/ScheduledValidatorPruneDto';

export enum ErrorType {
  UNAUTHORIZED = 'UNAUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  SERVER_ERROR = 'SERVER_ERROR',
  FORBIDDEN = 'FORBIDDEN',
  UNAVAILABLE = 'UNAVAILABLE',
  CLIENT_RESPONSIBLE = 'CLIENT_RESPONSIBLE',
  VALIDATION = 'VALIDATION',
  UNKNOWN = 'UNKNOWN',
  IGNORED = 'IGNORED',
}

export enum MemoryEnum {
  Ei = 'Ei',
  Pi = 'Pi',
  Ti = 'Ti',
  Gi = 'Gi',
  Mi = 'Mi',
  Ki = 'Ki',
}

export enum QueryKeys {
  DOMAINS = 'DOMAINS',
  REMOTE_DOMAINS = 'REMOTE_DOMAINS',
  PARTICIPANTS = 'PARTICIPANTS',
  REMOTE_PARTICIPANTS = 'REMOTE_PARTICIPANTS',
  NAVIGATORS = 'NAVIGATORS',
  DARS = 'DARS',
  USERS = 'USERS',
  APPLICATIONS = 'APPLICATIONS',
  FILES = 'FILES',
  CONTRACTS = 'CONTRACTS',
  COMMANDS = 'COMMANDS',
  DASHBOARD = 'DASHBOARD',
  HEALTH_DUMP_FILE = 'HEALTH_DUMP_FILE',
  VALIDATORS = 'VALIDATORS',
  BACKUP = 'backup',
  PRUNE = 'prune',
  HISTORY = 'history',
  REMOTE = 'remote',
  SECRETS = 'secrets',
  PROXY = 'proxy',
  RESTORE = 'restore',
  DUMPS = 'dumps',
}

export enum QueryEntityKeys {
  PARTIES_ENTITY = 'parties',
  ALL_PARTIES_ENTITY = 'allParties',
  LOCAL_PARTIES_ENTITY = 'localParties',
  EXTERNAL_PARTIES_ENTITY = 'externalParties',
  SCHEDULE = 'schedule',
}

// TODO
export enum EventType {
  addParticipant = 'ADDED Participant',
  removeParticipant = 'DELETED Participant',
  addDomain = 'ADDED Domain',
  removeDomain = 'DELETED Domain',
}

export enum RightType {
  CanActAs = 'CanActAs',
  CanReadAs = 'CanReadAs',
  CanExecuteAs = 'CanExecuteAs',
  ParticipantAdmin = 'ParticipantAdmin',
  CanReadAsAnyParty = 'CanReadAsAnyParty',
  CanExecuteAsAnyParty = 'CanExecuteAsAnyParty',
  IdentityProviderAdmin = 'IdentityProviderAdmin',
}

export const API_VERSION_V1 = 'v1';
export const API_VERSION_V2 = 'v2';

export const durationUnits: DurationUnit[] = ['s', 'm', 'h', 'd', 'w', 'mo'];

/** localStorage key for the persisted validator API (wallet) token store */
export const WALLET_TOKEN_STORE_KEY = 'wallet-token-store';
export const SCAN_PERSIST_KEY = 'api-scan-store';
export const VALIDATOR_PERSIST_KEY = 'api-validator-store';
